import React from 'react';

import {SUPPORT_SEARCH_URL} from 'app/urls';
import {gt} from 'app/utils/i18n';

interface Props {
  text: React.ReactNode;
  showSearchHelp?: boolean;
}

export function DashboardItemsCounter({
  text,
  showSearchHelp = false,
}: Props): JSX.Element | null {
  return (
    <div className="my-2 small">
      <span>
        {text}{' '}
        {showSearchHelp ? (
          <a href={SUPPORT_SEARCH_URL}>{gt('search help')}</a>
        ) : null}
      </span>
    </div>
  );
}
